export const api = "https://api.procaminspect.com";

// export const api = "http://localhost:5010";


// export const OAUTH_FALLBACK_URL = "http://localhost:3000/reset-password"; //local

export const OAUTH_FALLBACK_URL =
  "https://www.api.procaminspect.com/reset-password"; //dev env
